import React from 'react';
import {Button} from 'antd';

const handleDownload = (url, file, id) => {
  let link = `${url}?file_name=${file}&id=${id}`;
  document.location = link;
}

const ResultListActionButtons = (props) => {
  // console.log(props);
  const {link, id, url} = props.text;
  return(
    <span>
      <Button 
        type="primary" 
        ghost 
        icon="download"
        onClick={()=>handleDownload(url, link, id)}>Download
      </Button>
    </span>
  );
}

export default ResultListActionButtons;